<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="140px">
      <el-form-item label="位号" prop="bitIndex">
        <Select
          style="width: 240px;"
          placeholder="位号"
          v-model="form.bitIndex"
          :options="bitIndexList"
        >
        </Select>
      </el-form-item>
      <el-form-item label="异常类型" prop="excType">
        <Select
          style="width: 240px;"
          placeholder="异常类型"
          v-model="form.excType"
          :options="excTypeList"
        >
        </Select>
      </el-form-item>
      <el-form-item label="异常情况" prop="excSituation">
        <el-input v-model.trim="form.excSituation" clearable placeholder="异常情况"></el-input>
      </el-form-item>
      <el-form-item label="异常描述" prop="excDescribe">
        <el-input
          v-model.trim="form.excDescribe"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="异常描述"
          resize="none"
        ></el-input>
      </el-form-item>
      <el-form-item label="自动上报时间(h)" prop="delayTime">
        <el-switch v-model="form.delayState" active-text="上报" inactive-text="不上报"></el-switch>
        <el-input-number
          v-model="form.delayTime"
          controls-position="right"
          :min="0"
          :step="0.5"
          step-strictly
          v-if="form.delayState"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: this.visible,
      bitIndexList: [],
      excTypeList: [],
      form: {
        id: '',
        bitIndex: '',
        excType: '',
        excSituation: '',
        excDescribe: '',
        delayState: false,
        delayTime: 0
      },
      rules: {
        bitIndex: [
          {
            required: true,
            message: '请选择位号',
            trigger: 'change'
          }
        ],
        excType: [
          {
            required: true,
            message: '请选择异常类型',
            trigger: 'change'
          }
        ],
        excSituation: [
          {
            required: true,
            message: '请填写异常情况',
            trigger: ['blur', 'change']
          }
        ],
        excDescribe: [
          {
            required: true,
            message: '请填写异常描述',
            trigger: ['blur', 'change']
          }
        ],
        delayTime: [
          {
            required: true,
            message: '请填写自动上报时间',
            trigger: ['blur', 'change']
          }
        ]
      },
      addApi: this.$api.basicdata.alarm_type_add,
      updateApi: this.$api.basicdata.alarm_type_update
    }
  },
  mounted() {
    // 位号下拉框
    for (let i = 0; i < 16; i++) {
      let str = 'B' + i
      this.bitIndexList.push({
        code: i,
        name: str
      })
    }
    // 异常类型下拉框
    this.excTypeList.push(
      {
        code: '01',
        name: '预警'
      },
      {
        code: '02',
        name: '故障'
      }
    )
    if (this.row.id) {
      this.queryDetail(this.row)
    }
  },
  methods: {
    queryDetail(row) {
      let data = JSON.parse(JSON.stringify(row))
      this.form.id = data.id
      this.form.bitIndex = data.bitIndex
      this.form.excType = data.excType
      this.form.excSituation = data.excSituation
      this.form.excDescribe = data.excDescribe

      if (data.delayTime === -1) {
        this.form.delayState = false
        this.form.delayTime = 0
      } else {
        this.form.delayState = true
        this.form.delayTime = data.delayTime
      }
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            devType: '01',
            id: this.form.id,
            bitIndex: this.form.bitIndex,
            excType: this.form.excType,
            excSituation: this.form.excSituation,
            excDescribe: this.form.excDescribe
          }
          if (this.form.delayState) {
            params.delayTime = this.form.delayTime
          } else {
            params.delayTime = -1
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
